import './AppBar.scss';
import { FC } from 'react';
import { NavbarActions } from '../NavbarActions/NavbarActions';
import CandidateInfo from './CandidateInfo/CandidateInfo';

interface IAppBar {}

const AppBar: FC<IAppBar> = () => {
  return (
    <header>
      <div className="AppBar">
        <CandidateInfo />
        <NavbarActions />
      </div>
    </header>
  );
};

export default AppBar;
